import type { Observacao } from '../../api/hooks/useObservacoes';

export const AVISO_PEDAGOGICO_PREFIX = '[AVISO_PEDAGOGICO:';
export const OBSERVACAO_EDICAO_DIAS_PROFESSOR = 7;
export function isAvisoPedagogico(obs: Pick<Observacao, 'descricao' | 'titulo'>): boolean {
  return (
    (obs.descricao?.startsWith(AVISO_PEDAGOGICO_PREFIX) ?? false) ||
    (obs.titulo?.startsWith('Aviso escolar') ?? false) ||
    (obs.titulo?.startsWith('Destaque escolar') ?? false)
  );
}

/** Texto amigável sem o prefixo técnico do aviso estruturado. */
export function descricaoExibicao(descricao: string): string {
  if (!descricao.startsWith(AVISO_PEDAGOGICO_PREFIX)) return descricao;
  const semTag = descricao.replace(/^\[AVISO_PEDAGOGICO:[^\]]+\]\s*/, '');
  return semTag || descricao;
}

export function formatDataCurta(iso?: string) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  } catch {
    return '';
  }
}

function inicioDoDia(d: Date) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

/** Espelha regra do backend (fonte da verdade continua no servidor). */
export function professorPodeEditarObservacao(obs: Pick<Observacao, 'dataReferencia' | 'criadoEm' | 'descricao'>) {
  if (isAvisoPedagogico(obs as any)) return false;
  const ref = obs.dataReferencia ? new Date(obs.dataReferencia) : new Date(obs.criadoEm);
  const hoje = inicioDoDia(new Date());
  const dataRef = inicioDoDia(ref);
  const diffDias = Math.floor((hoje.getTime() - dataRef.getTime()) / 86400000);
  return diffDias <= OBSERVACAO_EDICAO_DIAS_PROFESSOR;
}